<template>
  <div v-if="events.length > 0">
    <div class="text-left">
      <v-row justify="center">
        <v-col cols="12" sm="2">
          <p><b>Class</b></p>
          <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list"
            item-text="standard" item-value="id" label="Class" outlined persistent-hint hint="Please Select Class"
            @change="getEventsFilter()" />
          <!-- @change="getEventsFilter()" -->
        </v-col>
        <v-col cols="12" sm="2">
          <p><b>Event Type</b></p>
          <v-autocomplete color="#0F2027" dense rounded required v-model="event_type" :items="event_type_list"
            item-text="name" item-value="id" label="Event Type" outlined persistent-hint hint="Please Select Event Type"
            @change="getEventsFilter()" />
          <!-- " -->
        </v-col>
      </v-row>
    </div>
    <div class="text-right">
      <v-chip class="ma-2" color="brand">
        <v-icon @click="reload" title="Reload Calendar" dark color="white">mdi-reload</v-icon>
      </v-chip>
    </div>

    <v-sheet tile color="grey lighten-3">
      <v-row dense>
        <v-col cols="12" sm="1" md="1">
          <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="2" md="1">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on" class="month-dropDown">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Month</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="1" md="1"></v-col>
        <v-col cols="12" sm="3" md="5">
          <center>
            <!-- <h1 class="curr-month" v-if="curr_month != null"> -->
            <!-- {{ curr_month }} - {{ current_ay_name.split('-')[1] }} -->
            <!-- {{ curr_month }} {{ current_ay_name ? ' - ' + current_ay_name.split('-')[1] : '' }}
            </h1> -->
            <h1 class="curr-month">
              {{ currentDisplayMonth }} - {{ displayYear }}
            </h1>
            <!-- <h1 class="curr-month" v-else>{{ title }}</h1> -->
          </center>
        </v-col>
        <v-col cols="12" sm="2" md="2" align="right">
          <v-select v-model="weekday" :items="weekdays" dense outlined hide-details label="weekdays"
            class="mt-1 weekDrop"></v-select>
        </v-col>
        <v-col cols="12" sm="2" md="1" align="right">
          <v-chip class="ma-2" color="brand onBrand--text" @click="setToday">Go To Today
          </v-chip>
        </v-col>
        <v-col cols="12" sm="1" md="1" align="right">
          <v-btn icon class="ma-2" @click="$refs.calendar.next()">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-sheet>
    <v-sheet height="520">
      <v-calendar ref="calendar" v-model="focus" :weekdays="weekday" color="primary" :type="type" :events="events"
        :min="minDate" :max="maxDate" :event-overlap-threshold="30" :event-color="getEventColor"
        @change="onCalendarChange" @click:event="showEvent" @click:more="viewDay" @click:day="getdata"></v-calendar>
    </v-sheet>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="500">
          <v-card>
            <v-card-title class="headline" primary-title>
              {{ tempevents.name }}
            </v-card-title>

            <v-card-text>
              <div class="headline mb-2">
                Description : {{ tempevents.description }}
              </div>
              <v-chip class="mr-2" color="lightgreen" text-color="white">
                <v-icon left>mdi-brightness-5</v-icon>
                Class: {{ tempevents.std }}
              </v-chip>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialog = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import { months } from "moment";
export default {
  props: {
    ay: Number,
    current_ay_name: String,
  },
  data: () => ({
    focus: new Date().toISOString().substr(0, 10), // "YYYY-MM-DD"
    dialog: false,
    datetime: null,
    title: "",
    type: "month",
    // types: ["month", "week", "day"],
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
    },
    minDate: '',
    maxDate: '',
    mode: "stack",
    modes: ["stack", "column"],
    weekday: [0, 1, 2, 3, 4, 5, 6],
    weekdays: [
      { text: "Sun - Sat", value: [0, 1, 2, 3, 4, 5, 6] },
      { text: "Mon - Sun", value: [1, 2, 3, 4, 5, 6, 0] },
      { text: "Mon - Fri", value: [1, 2, 3, 4, 5] },
    ],
    value: "",
    events: [],
    tempevents: { name: "", description: "", std: "", grno: "" },
    selectedElement: null,

    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],
    months: [
      "",
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    curr_month: null,
    event_type_list: [],
    standard_list: [],
    standard: "",
    event_type: "",
  }),

  watch: {
    focus(newVal) {
      console.log("FOCUS CHANGED", newVal);
    }
  },
  computed: {
    currentDisplayMonth() {
      const d = new Date(this.focus);

      if (isNaN(d)) return "";

      return this.months[d.getMonth() + 1];
    },

    // Determine year using academic-year logic you had (Jan/Feb/Mar -> endYear)
    displayYear() {
      if (!this.focus) return "";

      const d = new Date(this.focus);

      return d.getFullYear();
    }

  },
  methods: {
    initMonthYear() {
      // Prefer focus, otherwise try calendar ref
      let dateStr = this.focus;

      // If calendar exposes start as a string/object prefer that
      if (this.$refs.calendar && this.$refs.calendar.start) {
        const start = this.$refs.calendar.start;
        // If start is an ISO string (v-calendar may give "YYYY-MM-DD")
        if (typeof start === "string") {
          dateStr = start;
        } else if (start && typeof start.month !== "undefined") {
          // if start is { month: 1..12, year: 2025 } or { month: 0..11, year: 2025 }
          // Try to determine whether month is 0-based or 1-based:
          const monthValue = start.month;
          const yearValue = start.year || new Date().getFullYear();

          // Heuristic: if monthValue > 12 assume 0-based? (unlikely)
          // Most Vuetify versions give month as 1-based; if month <= 12 treat as 1-based
          const monthZeroIndex =
            monthValue >= 1 && monthValue <= 12 ? monthValue - 1 : monthValue;
          const built = new Date(yearValue, monthZeroIndex, 1);
          dateStr = built.toISOString().substr(0, 10);
        }
      }

      // Finally update curr_month from dateStr
      if (dateStr) {
        const parsed = new Date(dateStr);
        if (!isNaN(parsed)) {
          this.curr_month = this.months[parsed.getMonth() + 1];
          // also keep focus normalized to YYYY-MM-DD
          this.focus = parsed.toISOString().substr(0, 10);
        }
      } else {
        // Fallback to current month
        const now = new Date();
        this.curr_month = this.months[now.getMonth() + 1];
        this.focus = now.toISOString().substr(0, 10);
      }
    },

    handleButtonClick() {

      let data = {
        ay: this.ay,
      };

      axios
        .post("AcademicPlanner/getadminAcademicPlanner", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            if (res.data.planning_list.length !== 0) {
              this.events = res.data.planning_list;
              // console.log("in API", this.events);
            }
            this.event_type_list = res.data.event_type_list;
            this.standard_list = res.data.standard_list;
            this.current_ay_name = res.data.current_ay_name || '';
            this.maxDate = res.data.current_ay_training_end_date;
            this.minDate = res.data.current_ay_training_start_date;
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    onCalendarChange(payload) {
      const start = payload && payload.start ? payload.start : payload;

      if (!start) return;
      console.log("BEFORE", this.focus);
      if (typeof start === "string") {
        this.focus = start;
      } else if (typeof start === "object") {
        if (start.date) {
          this.focus = start.date;
        } else if (start.year !== undefined && start.month !== undefined) {
          const built = new Date(start.year, start.month - 1, 1);
          this.focus = built.toISOString().substr(0, 10);
        }
        console.log("AFTER", this.focus);
      }
      console.log("calendar changed", start);
      console.log("focus", this.focus);
      this.$forceUpdate();
    },
    getDisplayYear(monthName) {
      if (!this.current_ay_name) return '';

      const [startYear, endYear] = this.current_ay_name.split('-').map(Number);
      const monthIndex = this.months.indexOf(monthName); // e.g., "November" → 11

      // Months: Jan=1 ... Dec=12
      // If current month is Jan, Feb, Mar → belongs to endYear (2026)
      // Otherwise → belongs to startYear (2025)
      if (monthIndex >= 1 && monthIndex <= 3) { // Jan, Feb, Mar
        return endYear;
      } else {
        return startYear;
      }
    },

    getEventsFilter() {
      const formData = {
        standard: this.standard,
        ay: this.ay,
        event_type: this.event_type,
        curr_month: this.curr_month,
      };
      axios
        .post("AcademicPlanner/getEventsFilter", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            if (res.data.planning_list.length !== 0) {
              this.events = res.data.planning_list;
              console.log("in API", this.events);
            }
            // this.title = this.getMonthYYYYMMDD(this.$refs.calendar.start);
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    viewDay(payload) {
      console.log("click more payload", payload);

      if (payload && payload.date) {
        this.focus = payload.date;
      }

      this.type = "day";
    },

    setToday() {
      const today = new Date();
      const iso = today.toISOString().substr(0, 10);

      // Update the focus for reactivity
      this.focus = iso;
      this.curr_month = this.months[today.getMonth() + 1];

      this.$nextTick(() => {
        if (this.$refs.calendar) {
          // Tell Vuetify calendar to actually jump to today
          this.$refs.calendar.move(0);   // forces refresh
          this.$refs.calendar.focus = iso; // sets visible month properly
        }
      });
    },
    dateTime() {
      let dt = this.formatDate(this.datetime, true);
      const formData = {
        datetime: dt,
      };
      console.log("formData");
      console.log(formData);
      axios
        .post("tryNError/dateTime", formData)
        .then((res) => {
          if (res.data.msg == "200") {
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    showEvent({ nativeEvent, event }) {
      // console.log("in show event", event);
      this.tempevents.name = event.name;
      this.tempevents.description = event.description;
      this.tempevents.std = event.standard;
      this.tempevents.grno = event.divissionoffering;
      this.selectedElement = nativeEvent.target;

      this.dialog = true;
      // console.log("in showEvent", this.selectedElement);

      //alert(event.name + " " + event.description + " " + event.std);
    },
    getdata({ day }) {
      // alert(day)
    },
    getEventData(start) {
      return start == this.value;
    },
    getEvents() {
      // alert(this.value);
    },

    getEventColor(event) {
      return event.color;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    formatDate(a, withTime) {
      return withTime
        ? `${a.getFullYear()}-${a.getMonth() + 1
        }-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    getMonthYYYYMMDD(date) {
      var num_month = date.split("-");
      var months = [
        "",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months[parseInt(num_month[1])];
    },
    reload() {
      const data = {
        ay: this.ay,
      };
      axios
        .post("AcademicPlanner/getadminAcademicPlanner", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            if (res.data.planning_list.length !== 0) {
              this.events = res.data.planning_list;
              this.maxDate = res.data.current_ay_training_end_date;
              this.minDate = res.data.current_ay_training_start_date;
              // console.log("in API", this.events);
            }

            this.title = this.getMonthYYYYMMDD(this.$refs.calendar.start);
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
  },
  mounted() {
    this.events.push({
      name: "Happy New Year", //title
      start: "2020-01-01", //this.formatDate(res.data.date, !true),

      // start: "2022-05-18", //this.formatDate(res.data.date, !true),
      //   end: "2022-05-20", //this.formatDate(res.data.date, !true),
      color: "",
      description: "",
      standard: "",
      divissionoffering: "",
    });
    this.handleButtonClick();
    this.$nextTick(() => {
      this.initMonthYear(); // initial load

      // Also listen to calendar navigation
      this.$watch('$refs.calendar.start', () => {
        this.initMonthYear();
      }, { deep: true });
    });
  },
};
</script>
<style scoped>
.month-dropDown {
  margin-top: 2%;
}

.curr-month {
  font-size: 30px;
  color: var(--v-brand-base);
  display: inline-block;
  -webkit-transform: scale(1.5, 1);
  /* Safari and Chrome */
  -moz-transform: scale(1.5, 1);
  /* Firefox */
  -ms-transform: scale(1.5, 1);
  /* IE 9 */
  -o-transform: scale(1.5, 1);
  /* Opera */
}
</style>